<template>
  <div class="award">
    <div class="award__asset">
      <picture>
        <source
          media="--small"
          data-srcset="/static/images/award_asset.png"
        >

        <source
          media="--large"
          data-srcset="/static/images/award_asset@2x.png"
        >

        <img
          class="lazyload"
          data-sizes="auto"
          data-src="/static/images/award_asset@2x.png"
        >
      </picture>
    </div>
    <div class="award__content">
      <span class="award__content__title">{{ title }}</span>
      <br>
      <span class="award__content__year">{{ year }}</span>
    </div>
    <div class="award__asset award__asset--reverse">
      <picture>
        <source
          media="--small"
          data-srcset="/static/images/award_asset.png"
        >

        <source
          media="--large"
          data-srcset="/static/images/award_asset@2x.png"
        >

        <img
          class="lazyload"
          data-sizes="auto"
          data-src="/static/images/award_asset@2x.png"
        >
      </picture>
    </div>
  </div>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'AwardView',

  mixins: [variant],

  props: {
    title: {
      type: String,
      default: 'award'
    },
    year: {
      type: String,
      default: 'award'
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/awards/award-view.scss" scoped></style>



// WEBPACK FOOTER //
// award-view.vue